(function () {
  'use strict';

  function publish(eventName, details) {
    var payload = Object.assign({
      page_path: window.location.pathname,
      page_template: document.querySelector('main[data-template]')?.dataset.template || ''
    }, details || {});

    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    } else {
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }

    if (window.Shopify?.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish(eventName, payload);
      } catch (error) {
        // A missing or blocked pixel should not affect the storefront.
      }
    }

    document.dispatchEvent(new CustomEvent('xiaoyeah:conversion', {
      detail: { event: eventName, payload: payload }
    }));
  }

  function markSuccessOnce(eventName) {
    var key = 'xiaoyeah_conversion_' + eventName + '_' + window.location.pathname;
    try {
      if (window.sessionStorage.getItem(key) === '1') return false;
      window.sessionStorage.setItem(key, '1');
    } catch (error) {
      // Private browsing or blocked storage should not stop event delivery.
    }
    return true;
  }

  function trackSuccessfulForms() {
    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      if (!form.querySelector('.form-status-list.form__message')) return;

      var isMockup = form.id === 'FreeDigitalMockupForm';
      var eventName = isMockup ? 'mockup_request_submitted' : 'quote_form_submitted';

      if (markSuccessOnce(eventName)) {
        publish(eventName, {
          form_id: form.id || 'contact-form'
        });
      }
    });
  }

  function linkPath(link) {
    var href = link.getAttribute('href') || '';
    if (href.toLowerCase().indexOf('mailto:') === 0) return 'mailto';

    try {
      return new URL(href, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function eventForLink(link, path) {
    var explicitEvent = link.getAttribute('data-analytics-event');
    if (explicitEvent) return explicitEvent;
    if (path === 'mailto') return 'contact_email_click';
    if (path === '/pages/free-digital-mock-up') return 'mockup_cta_clicked';
    if (path === '/pages/custom-pvc-pricing-moq-lead-time') return 'pricing_guide_clicked';
    if (path === '/blogs/inside-xiaoyeah/pvc-vs-acrylic-keychains-how-to-choose') return 'buyer_guide_clicked';
    if (path === '/collections/custom-orders-1') return 'custom_formats_clicked';
    return '';
  }

  function trackLinkClick(event) {
    var link = event.target.closest ? event.target.closest('a') : null;
    if (!link) return;

    var path = linkPath(link);
    var eventName = eventForLink(link, path);
    if (!eventName) return;

    publish(eventName, {
      link_path: path,
      link_text: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120)
    });
  }

  function init() {
    trackSuccessfulForms();
    document.addEventListener('click', trackLinkClick, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();